<div *ngIf="inited">
    <sm-toolbar>
        <p-button icon="fas fa-plus" label="Neu" (onClick)="addFieldTrip()">
        </p-button>
    </sm-toolbar>
    <sm-table [data]="table" [deltaHeight]=150 [allowExport]=false (onCellClicked)="fieldTripClicked($event)"></sm-table>
</div>
